/**
 * ACARS & VDL2 Frequency Description Map
 * Maps frequency (MHz) to human-readable descriptions
 */

const FREQUENCY_DESCRIPTIONS = {
  // ACARS Frequencies (131 MHz band)
  131.525: { type: 'ACARS', description: 'ACARS — SITA European primary' },
  131.550: { type: 'ACARS', description: 'ACARS — ARINC primary' },
  131.725: { type: 'ACARS', description: 'ACARS — SITA secondary' },
  131.825: { type: 'ACARS', description: 'ACARS — ARINC secondary' },
  131.850: { type: 'ACARS', description: 'ACARS — additional channel' },

  // VDL Mode 2 Frequencies (136.7–136.975 MHz, ICAO European allocation)
  136.700: { type: 'VDL2', channel: 'AIR', description: 'VDL2 AIR — en-route airborne' },
  136.725: { type: 'VDL2', channel: 'AIR', description: 'VDL2 AIR — en-route airborne' },
  136.750: { type: 'VDL2', channel: 'AIR', description: 'VDL2 AIR — en-route airborne' },
  136.775: { type: 'VDL2', channel: 'AIR', description: 'VDL2 AIR — en-route airborne' },
  136.800: { type: 'VDL2', channel: 'AIR', description: 'VDL2 AIR — en-route airborne' },
  136.825: { type: 'VDL2', channel: 'GND', description: 'VDL2 GND — airport ground station' },
  136.850: { type: 'VDL2', channel: 'AIR', description: 'VDL2 AIR — en-route airborne' },
  136.875: { type: 'VDL2', channel: 'GND', description: 'VDL2 GND — airport ground station' },
  136.900: { type: 'VDL2', channel: 'AIR', description: 'VDL2 AIR — en-route airborne' },
  136.925: { type: 'VDL2', channel: 'GND', description: 'VDL2 GND — airport ground station' },
  136.950: { type: 'VDL2', channel: 'AIR', description: 'VDL2 AIR — en-route airborne' },
  136.975: { type: 'VDL2', channel: 'CSC', description: 'VDL2 CSC — Common Signalling Channel' },
};

/**
 * Get a tooltip description for a frequency
 * @param {number} frequencyMhz - frequency in MHz
 * @returns {string} human-readable description
 */
export function getFrequencyTooltip(frequencyMhz) {
  if (!frequencyMhz) return '';

  // Round to 3 decimal places for lookup
  const key = Math.round(frequencyMhz * 1000) / 1000;
  const desc = FREQUENCY_DESCRIPTIONS[key];
  if (desc) {
    return `${key.toFixed(3)} MHz — ${desc.description}`;
  }

  // Fallback by range
  if (frequencyMhz >= 136.0 && frequencyMhz < 137.5) {
    return `${frequencyMhz.toFixed(3)} MHz — VDL Mode 2`;
  }
  if (frequencyMhz >= 129.0 && frequencyMhz < 133.0) {
    return `${frequencyMhz.toFixed(3)} MHz — ACARS`;
  }

  return `${frequencyMhz.toFixed(3)} MHz`;
}

export default FREQUENCY_DESCRIPTIONS;
